import { StatesList } from "../../../../../../../core/form-engine/projects/form-engine/src/interfaces/prefixes-list";
import { prefixes_list, statesOptions } from "../../../../../../../core/form-engine/projects/form-engine/src/services/data-entry.configuration";

export const countryOptions = {
    "emea":
        // emea
        [
            { value: 'be', label: 'Belgium' },
            { value: 'bg', label: 'Bulgaria' },
            { value: 'ba', label: 'Bosnia and Herzegovina' },
            { value: 'je', label: 'Jersey' },
            { value: 'by', label: 'Belarus' },
            { value: 'ru', label: 'Russia' },
            { value: 'rs', label: 'Serbia' },
            { value: 'ro', label: 'Romania' },
            { value: 'gr', label: 'Greece' },
            { value: 'gg', label: 'Guernsey' },
            { value: 'gb', label: 'United Kingdom' },
            { value: 'gi', label: 'Gibraltar' },
            { value: 'hr', label: 'Croatia' },
            { value: 'hu', label: 'Hungary' },
            { value: 'pt', label: 'Portugal' },
            { value: 'sj', label: 'Svalbard and Jan Mayen' },
            { value: 'pl', label: 'Poland' },
            { value: 'ee', label: 'Estonia' },
            { value: 'il', label: 'Israel' },
            { value: 'it', label: 'Italy' },
            { value: 'es', label: 'Spain' },
            { value: 'me', label: 'Montenegro' },
            { value: 'md', label: 'Moldova' },
            { value: 'mc', label: 'Monaco' },
            { value: 'mk', label: 'Macedonia' },
            { value: 'mt', label: 'Malta' },
            { value: 'im', label: 'Isle of Man' },
            { value: 'fg', label: 'French Guiana' },
            { value: 'fi', label: 'Finland' },
            { value: 'fo', label: 'Faroe Islands' },
            { value: 'fr', label: 'France' },
            { value: 'nl', label: 'Netherlands' },
            { value: 'no', label: 'Norway' },
            { value: 'xk', label: 'Kosovo' },
            { value: 'ch', label: 'Switzerland' },
            { value: 'cz', label: 'Czech Republic' },
            { value: 'cy', label: 'Cyprus' },
            { value: 'sk', label: 'Slovakia' },
            { value: 'si', label: 'Slovenia' },
            { value: 'sm', label: 'San Marino' },
            { value: 'se', label: 'Sweden' },
            { value: 'dk', label: 'Denmark' },
            { value: 'de', label: 'Germany' },
            { value: 'li', label: 'Liechtenstein' },
            { value: 'lv', label: 'Latvia' },
            { value: 'lt', label: 'Lithuania' },
            { value: 'lu', label: 'Luxembourg' },
            { value: 'va', label: 'Vatican' },
            { value: 'ad', label: 'Andorra' },
            { value: 'is', label: 'Iceland' },
            { value: 'al', label: 'Albania' },
            { value: 'at', label: 'Austria' },
            { value: 'ax', label: 'Aland Islands' },
            { value: 'ie', label: 'Ireland' },
            { value: 'ua', label: 'Ukraine' }
        ],
    "nafta":
        // nafta
        [
            { value: 'bb', label: 'Barbados' },
            { value: 'bl', label: 'Saint Barthelemy' },
            { value: 'bm', label: 'Bermuda' },
            { value: 'jm', label: 'Jamaica' },
            { value: 'bq', label: 'Bonaire, Saint Eustatius and Saba ' },
            { value: 'bs', label: 'Bahamas' },
            { value: 'bz', label: 'Belize' },
            { value: 'gt', label: 'Guatemala' },
            { value: 'gp', label: 'Guadeloupe' },
            { value: 'gd', label: 'Grenada' },
            { value: 'sv', label: 'El Salvador' },
            { value: 'gl', label: 'Greenland' },
            { value: 'ht', label: 'Haiti' },
            { value: 'hn', label: 'Honduras' },
            { value: 'pr', label: 'Puerto Rico' },
            { value: 'pa', label: 'Panama' },
            { value: 'pm', label: 'Saint Pierre and Miquelon' },
            { value: 'mf', label: 'Saint Martin' },
            { value: 'mq', label: 'Martinique' },
            { value: 'ms', label: 'Montserrat' },
            { value: 'mx', label: 'Mexico' },
            { value: 'ni', label: 'Nicaragua' },
            { value: 'ca', label: 'Canada' },
            { value: 'cr', label: 'Costa Rica' },
            { value: 'cw', label: 'Curacao' },
            { value: 'cu', label: 'Cuba' },
            { value: 'sx', label: 'Sint Maarten' },
            { value: 'kn', label: 'Saint Kitts and Nevis' },
            { value: 'ky', label: 'Cayman Islands' },
            { value: 'do', label: 'Dominican Republic' },
            { value: 'dm', label: 'Dominica' },
            { value: 'vg', label: 'British Virgin Islands' },
            { value: 'us', label: 'United States' },
            { value: 'lc', label: 'Saint Lucia' },
            { value: 'tt', label: 'Trinidad and Tobago' },
            { value: 'tc', label: 'Turks and Caicos Islands' },
            { value: 'vc', label: 'Saint Vincent and the Grenadines' },
            { value: 'ag', label: 'Antigua and Barbuda' },
            { value: 'ai', label: 'Anguilla' },
            { value: 'vi', label: 'U.S. Virgin Islands' },
            { value: 'aw', label: 'Aruba' }
        ],
    "latam":
        // latam
        [
            { value: 'bo', label: 'Bolivia' },
            { value: 'br', label: 'Brazil' },
            { value: 'gy', label: 'Guyana' },
            { value: 'gf', label: 'French Guiana' },
            { value: 've', label: 'Venezuela' },
            { value: 'py', label: 'Paraguay' },
            { value: 'pe', label: 'Peru' },
            { value: 'ec', label: 'Ecuador' },
            { value: 'fk', label: 'Falkland Islands' },
            { value: 'co', label: 'Colombia' },
            { value: 'cl', label: 'Chile' },
            { value: 'sr', label: 'Suriname' },
            { value: 'uy', label: 'Uruguay' },
            { value: 'ar', label: 'Argentina' }
        ],
    "iap": [ //apac (iap)
        { value: 'au', label: 'Australia' },
        { value: 'in', label: 'India' },
        { value: 'kr', label: 'Korea' },
        { value: 'jp', label: 'Japan' }
    ]
}

export const userAccountConfig = {
    "accountPreferenceConfig": {
        "sideNav": [
            { "key": "personal-information", "label": "Personal Information" },
            { "key": "mailing-address", "label": "Mailing Address" },
            { "key": "billing-address", "label": "Billing Address" },
            { "key": "privacy", "label": "Privacy" },
            { "key": "website-preferences", "label": "Website Preferences" },
            { "key": "payment-information", "label": "Payment Information" }
        ],
        "breadcrumbs": [
            { "link": "/user-profile", "label": "Profile" }
        ],
        "forms": {
            "personalInfoForm": {
                "id": "personal_information_form",
                "fields": [
                    {
                        "id": "firstName",
                        "type": "text",
                        "title": "firstName",
                        "ariaLabel": "firstName",
                        "formID": "personal_information_form",
                        "label": "First Name",
                        "regex": "/^[^0-9_!¡?÷?¿\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,40}$/",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "First Name must contain only letters and be longer than 2 characters",
                            "required": "The first name field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "lastName",
                        "type": "text",
                        "title": "lastName",
                        "ariaLabel": "lastName",
                        "formID": "personal_information_form",
                        "label": "Last Name",
                        "regex": "/^[^0-9_!¡?÷?¿\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,40}$/",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "Last Name must contain only letters and be longer than 2 characters",
                            "required": "The last name field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "userCountry",
                        "type": "select",
                        "title": "country",
                        "ariaLabel": "country",
                        "formID": "personal_information_form",
                        "label": "Country",
                        "regex": "",
                        "options": [
                            {
                                "value": "United States",
                                "key": "US"
                            },
                            {
                                "value": "India",
                                "key": "IN"
                            },
                            {
                                "value": "Italy",
                                "key": "IT"
                            }
                        ],
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "locale",
                        "type": "text",
                        "title": "language",
                        "ariaLabel": "language",
                        "formID": "personal_information_form",
                        "label": "Language",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "prefixMobile",
                        "type": "text",
                        "title": "prefixPhone",
                        "ariaLabel": "prefixPhone",
                        "formID": "personal_information_form",
                        "label": "Prefix",
                        "regex": "",
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "numberMobile",
                        "type": "text",
                        "title": "phones",
                        "ariaLabel": "phones",
                        "formID": "personal_information_form",
                        "label": "Phone",
                        "regex": "/^[0-9\\s]+$/",
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "The mobile phone number format is not valid",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "prefixHome",
                        "type": "text",
                        "title": "prefixHome",
                        "ariaLabel": "prefixHome",
                        "formID": "personal_information_form",
                        "label": "Prefix",
                        "regex": "",
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "numberHome",
                        "type": "text",
                        "title": "homePhones",
                        "ariaLabel": "homePhones",
                        "formID": "personal_information_form",
                        "label": "Home Phone Number",
                        "regex": "/^[0-9\\s]+$/",
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "The home phone number format is not valid",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    }
                ]
            },
            "mailingAddressForm": {
                "id": "mailing_add_form",
                "fields": [
                    {
                        "id": "country",
                        "type": "select",
                        "title": "country",
                        "ariaLabel": "country",
                        "formID": "mailing_add_form",
                        "label": "Country:*",
                        "regex": "",
                        "options": [],
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "streetAddress",
                        "type": "text",
                        "title": "streetAddress",
                        "ariaLabel": "streetAddress",
                        "formID": "mailing_add_form",
                        "label": "Street Address:*",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "aptSuiteBuildingFloor",
                        "type": "text",
                        "title": "aptSuiteBuildingFloor",
                        "ariaLabel": "aptSuiteBuildingFloor",
                        "formID": "mailing_add_form",
                        "label": "Apt, Suite, Building, Floor, etc.",
                        "regex": "",
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "city",
                        "type": "text",
                        "title": "city",
                        "ariaLabel": "city",
                        "formID": "mailing_add_form",
                        "label": "City:*",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "region",
                        "type": "select",
                        "title": "region",
                        "ariaLabel": "region",
                        "formID": "mailing_add_form",
                        "label": "Region/State/Provinces:*",
                        "regex": "",
                        "options": [],
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "zipcode",
                        "type": "text",
                        "title": "zipcode",
                        "ariaLabel": "zipcode",
                        "formID": "mailing_add_form",
                        "label": "Zip Code:*",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    }
                ]
            },
            "billingAddressForm": {
                "id": "billing_add_form",
                "fields": [
                    {
                        "id": "country",
                        "type": "select",
                        "title": "country",
                        "ariaLabel": "country",
                        "formID": "billing_add_form",
                        "label": "Country",
                        "regex": "",
                        "options": [],
                        "disabled": true,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "streetAddress",
                        "type": "text",
                        "title": "streetAddress",
                        "ariaLabel": "streetAddress",
                        "formID": "billing_add_form",
                        "label": "Street Address:*",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "aptSuiteBuildingFloor",
                        "type": "text",
                        "title": "aptSuiteBuildingFloor",
                        "ariaLabel": "aptSuiteBuildingFloor",
                        "formID": "billing_add_form",
                        "label": "Apt, Suite, Building, Floor, etc.",
                        "regex": "",
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "city",
                        "type": "text",
                        "title": "city",
                        "ariaLabel": "city",
                        "formID": "billing_add_form",
                        "label": "City:*",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "region",
                        "type": "select",
                        "title": "region",
                        "ariaLabel": "region",
                        "formID": "billing_add_form",
                        "label": "Region/State/Provinces:*",
                        "regex": "",
                        "options": [],
                        "disabled": true,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "zipCode",
                        "type": "text",
                        "title": "zipCode",
                        "ariaLabel": "zipCode",
                        "formID": "billing_add_form",
                        "label": "Zip Code:*",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    }
                ]
            },
            "websitePreferenceForm": {
                "id": "website_preference_form",
                "fields": [
                    {

                        "id": "websitePreference",
                        "type": "select",
                        "title": "websitePreference",
                        "ariaLabel": "websitePreference",
                        "formID": "website_preference_form",
                        "label": "",
                        "regex": "",
                        "options": [
                            {
                                value: 'Metric',
                                label: 'km/L/C°/KPA'
                            }, {
                                value: 'Imperial UK',
                                label: 'Miles/Gals/°F UK/BAR'
                            }, {
                                value: 'Imperial US',
                                label: 'Miles/Gals/°F US/PSI'
                            }
                        ],
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    }
                ]
            },
        }
    },
    "securityPreferenceConfig": {
        "sideNav": [
            { "key": "password", "label": "Password" },
            { "key": "security-pin", "label": "Security PIN" },
            { "key": "security-qa", "label": "Security Q&A" }
        ],
        "breadcrumbs": [
            { "link": "/user-profile", "label": "Profile" }
        ],
        "forms": {
            "securityQAFormSingleQA": {
                "id": "securityQAForm",
                "fields": [
                    {
                        "id": "securityQuestion",
                        "type": "text",
                        "title": "securityQuestion",
                        "ariaLabel": "securityQuestion",
                        "formID": "securityQAForm",
                        "label": "Security Question *",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "securityAnswer",
                        "type": "text",
                        "title": "securityAnswer",
                        "ariaLabel": "securityAnswer",
                        "formID": "securityQAForm",
                        "label": "Security Answer *",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    }
                ]
            },
            "securityQAFormTwoQA": {
                "id": "securityQAForm",
                "fields": [
                    {
                        "id": "securityQuestion1",
                        "type": "text",
                        "title": "securityQuestion1",
                        "ariaLabel": "securityQuestion1",
                        "formID": "securityQAForm",
                        "label": "First Security Question *",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "securityAnswer1",
                        "type": "text",
                        "title": "securityAnswer1",
                        "ariaLabel": "securityAnswer1",
                        "formID": "securityQAForm",
                        "label": "First Security Answer *",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "securityQuestion2",
                        "type": "text",
                        "title": "securityQuestion2",
                        "ariaLabel": "securityQuestion2",
                        "formID": "securityQAForm",
                        "label": "Second Security Question *",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "securityAnswer2",
                        "type": "text",
                        "title": "securityAnswer2",
                        "ariaLabel": "securityAnswer2",
                        "formID": "securityQAForm",
                        "label": "Second Security Answer *",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    }
                ]
            }
        }
    },

    "vehiclePreferenceConfig": {
        "sideNav": [
            { "key": "vehicle-information", "label": "Vehicle Information" },
            { "key": "message-settings", "label": "Message Settings" },
            { "key": "emergency-contacts", "label": "Emergency Contacts" },
            { "key": "headunit", "label": "Headunit" }
        ],
        "breadcrumbs": [
            { "link": "/user-profile", "label": "Profile" }
        ],
        "forms": {
            "emergencyContactForm": {
                "id": "emergencyContactForm",
                "fields": [
                    {
                        "id": "contactName",
                        "type": "text",
                        "title": "contactName",
                        "ariaLabel": "contactName",
                        "formID": "emergencyContactForm",
                        "label": "Contact Name",
                        "regex": "^[^0-9_!¡?÷?¿\\\\+=@#$%ˆ&*(){}|~<>;:[\\]]{2,40}$",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "Contact Name must contain only letters and be longer than 2 characters",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "callingCode",
                        "type": "select",
                        "title": "callingCode",
                        "ariaLabel": "callingCode",
                        "formID": "emergencyContactForm",
                        "label": "Calling Code",
                        "regex": "",
                        "disabled": false,
                        "required": true,
                        "options": [],
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    },
                    {
                        "id": "phoneNumber",
                        "type": "text",
                        "title": "phoneNumber",
                        "ariaLabel": "phoneNumber",
                        "formID": "emergencyContactForm",
                        "label": "Phone Number",
                        "regex": "^\\+(93|355|213|1-684|376|244|1-264|672|1-268|54|374|297|61|43|994|1-242|973|880|1-246|375|32|501|229|1-441|975|591|387|267|55|246|1-284|673|359|226|257|855|237|1|238|1-345|236|235|56|86|61|61|57|269|682|506|385|53|599|357|420|243|45|253|1-767|1-809,1-829,1-849|670|593|20|503|240|291|372|251|500|298|679|358|33|689|241|220|995|49|233|350|30|299|1-473|1-671|502|44-1481|224|245|592|509|504|852|36|354|91|62|98|964|353|44-1624|972|39|225|1-876|81|44-1534|962|7|254|686|383|965|996|856|371|961|266|231|218|423|370|352|853|389|261|265|60|960|223|356|692|222|230|262|52|691|373|377|976|382|1-664|212|258|95|264|674|977|31|599|687|64|505|227|234|683|850|1-670|47|968|92|680|970|507|675|595|51|63|64|48|351|1-787,1-939|974|242|262|40|7|250|590|290|1-869|1-758|590|508|1-784|685|378|239|966|221|381|248|232|65|1-721|421|386|677|252|27|82|211|34|94|249|597|47|268|46|41|963|886|992|255|66|228|690|676|1-868|216|90|993|1-649|688|1-340|256|380|971|44|1|598|998|678|379|58|84|681|212|967|260|263)$|^[0-9]{5,18}$",
                        "disabled": false,
                        "required": true,
                        "messages": {
                            "info": "",
                            "pattern": "The mobile phone number format is not valid",
                            "required": "This field is required",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": true
                    }
                ]
            }
        }
    },
    "invehicleMessagesConfig": {
        "sideNav": [
            { "key": "in-vehicle-messages", "label": "In-Vehicle Messages" }
        ],
        "breadcrumbs": [
            { "link": "/user-profile", "label": "Profile" },
            { "link": "../vehicle-preferences", "label": "Vehicle Preferences" }
        ],
        "forms": {
        }
    },
    "messageSettingsConfig": {
        "sideNav": [
            { "key": "vehicle", "label": "Vehicle" },
            { "key": "primary-contact", "label": "Primary contact" },
            { "key": "add-a-contact", "label": "Add a contact" },
        ],
        "breadcrumbs": [
            { "link": "/user-profile", "label": "Profile" },
            { "link": "../vehicle-preferences", "label": "Vehicle Preferences" }
        ],
        "forms": {
            "secondaryContactForm": {
                "id": "",
                "fields": [
                    {
                        "id": "email",
                        "type": "email",
                        "title": "email",
                        "ariaLabel": "email",
                        "formID": "",
                        "label": "Email",
                        "regex": "",
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": false
                    }
                ]
            },
            "secondaryContactNameForm": {
                "id": "secondaryContactNameForm",
                "fields": [
                    {
                        "id": "SecondaryContactLabel",
                        "type": "text",
                        "title": "SecondaryContactLabel",
                        "ariaLabel": "SecondaryContactLabel",
                        "formID": "secondaryContactNameForm",
                        "label": "Secondary Contact Label",
                        "regex": "",
                        "disabled": false,
                        "required": false,
                        "messages": {
                            "info": "",
                            "pattern": "",
                            "required": "",
                            "success": ""
                        },
                        "showModified": true,
                        "showValidity": false
                    }
                ]
            }
        }
    }
}

export const countriesLangMapping = {
    countries: {
        fr: {
            label: 'Francia',
            languages: [
                {
                    code: 'fr',
                    label: 'Français'
                },
            ]
        },
        ca: {
            label: 'Canada',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                },
                {
                    code: 'fr',
                    label: 'Français'
                },
                {
                    code: 'es',
                    label: 'Español'
                }
            ]
        },
        us: {
            label: 'United States',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                },
                {
                    code: 'fr',
                    label: 'Français'
                },
                {
                    code: 'es',
                    label: 'Español'
                }
            ]
        },
        mx: {
            label: 'Mexico',
            languages: [
                {
                    code: 'es',
                    label: 'Español'
                },
                {
                    code: 'en',
                    label: 'English'
                }
            ]
        },
        gb: {
            label: 'Great Bretain',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                },
                {
                    code: 'fr',
                    label: 'Français'
                }
            ]
        },
        de: {
            label: 'Germany',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                },
                {
                    code: 'de',
                    label: 'German'
                }
            ]
        },
        it: {
            label: 'Italia',
            languages: [
                // {
                //   code: 'en',
                //   label: 'English'
                // },
                {
                    code: 'it',
                    label: 'Italiano'
                }
            ]
        },
        il: {
            label: 'Israel',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                }
            ]
        },
        fg: {
            label: 'French Guiana',
            languages: [
                {
                    code: 'fr',
                    label: 'Français'
                }
            ]
        },
        es: {
            label: 'Spagna',
            languages: [
                /*{
                  code: 'en',
                  label: 'English'
                },*/
                {
                    code: 'es',
                    label: 'Spagnolo'
                }
            ]
        },
        ch: {
            label: 'Switzerland',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                },
                {
                    code: 'de',
                    label: 'Deutsche'
                },
                {
                    code: 'it',
                    label: 'Italiano'
                }
            ]
        },
        br: {
            label: 'Brasil',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                },
                {
                    code: 'pt',
                    label: 'Portuguese'
                }
            ]
        },
        au: {
            label: 'Australia',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                }
            ]
        },
        kr: {
            label: 'Korea',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                },
                {
                    code: 'ko',
                    label: 'Korean'
                }
            ]
        },
        jp: {
            label: 'Japan',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                },
                {
                    code: 'ja',
                    label: 'Japanese'
                }
            ]
        },
        in: {
            label: 'India',
            languages: [
                {
                    code: 'en',
                    label: 'English'
                }
            ]
        },
        bg: {
            label: 'Bulgaria',
            languages: [
                {
                    code: 'bg',
                    label: 'Bulgarian'
                }
            ]
        }
    }
};

export const prefixes_lists = prefixes_list;
export const statesOption: StatesList = statesOptions;